export class AssignableCompartmentList {
  hubName: string;
  compartments: Compartments[];
}
export class Compartments {
  id: number;
  name: string;
  isSelected?: boolean;
}

export class CompartmentListData {
  compartmentList: AssignableCompartmentList[];
  hubIdList: number[];
}
